import React, { createContext, useContext, useState, ReactNode } from 'react';
import keycloak from './keycloak';

interface AuthContextType {
  isAuthenticated: boolean;
  refreshAuthState: () => void;
  login: (redirectUri?: string) => void;
  register: (redirectUri?: string) => void;
  logout: () => void;
}

const AuthContext = createContext<AuthContextType | undefined>(undefined);

export const AuthProvider: React.FC<{ children: ReactNode }> = ({
  children,
}) => {
  const [isAuthenticated, setIsAuthenticated] = useState(
    !!keycloak.authenticated,
  );

  const refreshAuthState = () => setIsAuthenticated(!!keycloak.authenticated);

  const login = (redirectUri = window.location.origin + '/comic') => {
    keycloak.login({ redirectUri });
  };

  const register = (redirectUri = window.location.origin + '/comic') => {
    keycloak.register({ redirectUri });
  };

  const logout = () => {
    keycloak.logout({ redirectUri: window.location.origin + '/' });
  };

  return (
    <AuthContext.Provider
      value={{ isAuthenticated, refreshAuthState, login, register, logout }}
    >
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
};
